/* =========================================================================
   GBN cart drawer, free-shipping bar and one-click add-ons.
   Markup: sections/gbn-cart-drawer.liquid, snippets/gbn-fs-bar.liquid,
   snippets/gbn-cart-addons.liquid. The drawer is re-rendered from Liquid via
   the Section Rendering API after every cart change.
   ========================================================================= */
(function() {
  'use strict';

  var SECTION_ID = 'gbn-cart-drawer';
  var CART_PAGE_SECTION_ID = 'cart-template';

  var routesEl = document.querySelector('[data-cart-routes]');
  if (!routesEl) return;
  var routes = JSON.parse(routesEl.innerHTML);
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var drawer = document.querySelector('[data-gbn-drawer]');
  var panel = drawer && drawer.querySelector('[data-gbn-drawer-panel]');
  var lastFocus = null;
  var closeTimer = null;

  var ICONS = {
    van:
      '<svg class="gbn-icon gbn-icon--van" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M2 6h12v9H2zM14 9h4l3 3v3h-7z"/><circle cx="6" cy="17" r="2" fill="#fff" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17" r="2" fill="#fff" stroke="currentColor" stroke-width="1.6"/></svg>',
    tick:
      '<svg class="gbn-icon gbn-icon--tick" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.5l3.2 3L17 9" stroke="#fff" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------------------------------------------------------------------
     Helpers
     --------------------------------------------------------------------- */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(cents, wholeIfRound) {
    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var digits = wholeIfRound && cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(digits);
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.json().then(function(json) {
        if (!response.ok) {
          var error = new Error(
            json.description || json.message || theme.strings.cartError
          );
          error.isFromServer = true;
          throw error;
        }
        return json;
      });
    });
  }

  function errorMessage(error) {
    return error && error.isFromServer && error.message
      ? error.message
      : theme.strings.cartError;
  }

  function setCartCount(count) {
    var bubble = document.querySelector('[data-cart-count-bubble]');
    var countEl = document.querySelector('[data-cart-count]');
    if (!bubble || !countEl) return;
    bubble.classList.toggle('hide', !count);
    countEl.textContent = count || '';
  }

  /* ---------------------------------------------------------------------
     Free-shipping bar
     The bar is rendered by Liquid. In the store's own currency it is already
     correct; in other currencies the threshold is converted here.
     --------------------------------------------------------------------- */
  function updateShippingBars(scope, totalCents) {
    var bars = (scope || document).querySelectorAll('[data-gbn-fs]');

    Array.prototype.forEach.call(bars, function(bar) {
      var sameCurrency = bar.getAttribute('data-same-currency') === 'true';

      // Liquid already rendered this bar correctly; nothing to do.
      if (typeof totalCents !== 'number' && sameCurrency) return;

      if (typeof totalCents === 'number') {
        bar.setAttribute('data-total', totalCents);
      }

      var total = parseInt(bar.getAttribute('data-total'), 10) || 0;
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      if (!sameCurrency) {
        var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        threshold = Math.round(threshold * rate);
      }
      if (!threshold) return;

      var remaining = threshold - total;
      var done = remaining <= 0;
      var pct = Math.max(0, Math.min(100, (total / threshold) * 100));

      var html = done
        ? ICONS.tick + '<span>' + escapeHtml(bar.getAttribute('data-text-success')) + '</span>'
        : ICONS.van +
          '<span>' +
          escapeHtml(bar.getAttribute('data-text-progress')).replace(
            '[amount]',
            '<strong class="gbn-fs__amount">' + formatMoney(remaining) + '</strong>'
          ) +
          '</span>';

      var msg = bar.querySelector('[data-gbn-fs-msg]');
      // Only touch the live region when the text changes, so screen readers
      // aren't spammed.
      if (msg && msg.getAttribute('data-html') !== html) {
        msg.innerHTML = html;
        msg.setAttribute('data-html', html);
      }

      bar.querySelector('[data-gbn-fs-fill]').style.width = pct + '%';
      bar.querySelector('[data-gbn-fs-track]').setAttribute('aria-valuenow', Math.round(pct));
      bar.querySelector('[data-gbn-fs-goal]').textContent = formatMoney(threshold, true);
      bar.classList.toggle('gbn-fs--done', done);
      bar.classList.remove('gbn-fs--pending');
    });
  }

  /* ---------------------------------------------------------------------
     Drawer: open / close / focus
     --------------------------------------------------------------------- */
  function focusable() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex^="-"])'),
      function(el) {
        return el.offsetParent !== null;
      }
    );
  }

  function onKeydown(evt) {
    if (evt.key === 'Escape') {
      close();
      return;
    }
    if (evt.key !== 'Tab') return;

    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (evt.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  }

  function open(options) {
    if (!drawer) return false;
    options = options || {};

    clearTimeout(closeTimer);
    lastFocus = options.trigger || document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('gbn-drawer-lock');
    // Force a reflow so the slide-in transition runs.
    drawer.getBoundingClientRect();
    drawer.classList.add('is-open');
    fitAddons();
    panel.focus();
    document.addEventListener('keydown', onKeydown);

    if (options.refresh) refresh();
    return true;
  }

  function close() {
    if (!drawer || drawer.hidden) return;

    drawer.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown);
    document.documentElement.classList.remove('gbn-drawer-lock');
    closeTimer = setTimeout(function() {
      drawer.hidden = true;
    }, 350);

    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  function setBusy(isBusy) {
    if (drawer) drawer.classList.toggle('is-busy', isBusy);
  }

  /* ---------------------------------------------------------------------
     Drawer: rendering
     --------------------------------------------------------------------- */
  /* Show as many add-ons as fit without making the drawer scroll. The cart
     items always stay; the subtitle goes, then add-ons from the end, then the whole
     add-on block, so the only scroll (if any) is the drawer body itself. */
  function fitAddons() {
    if (!drawer || drawer.hidden) return;
    var body = drawer.querySelector('[data-gbn-drawer-body]');
    var block = body && body.querySelector('.gbn-addons--drawer');
    if (!block) return;
    var rows = block.querySelectorAll('.gbn-addon');
    var sub = block.querySelector('.gbn-addons__sub');
    var shown = rows.length;
    var tooTall = function() { return body.scrollHeight > body.clientHeight + 1; };

    block.hidden = false;
    if (sub) sub.hidden = false;
    for (var i = 0; i < rows.length; i++) rows[i].hidden = false;

    // The subtitle goes first, then add-ons from the end.
    if (sub && tooTall()) sub.hidden = true;
    while (shown > 0 && tooTall()) {
      shown -= 1;
      rows[shown].hidden = true;
    }
    if (shown === 0) block.hidden = true;
  }

  var fitFrame = null;
  window.addEventListener('resize', function() {
    cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(fitAddons);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAddons);

  function renderDrawer(sectionHtml) {
    if (!drawer || !sectionHtml) return;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('[data-gbn-drawer-inner]');
    var current = drawer.querySelector('[data-gbn-drawer-inner]');
    if (!fresh || !current) return;

    var oldBody = current.querySelector('[data-gbn-drawer-body]');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;
    var oldFill = current.querySelector('[data-gbn-fs-fill]');
    var oldWidth = oldFill ? oldFill.style.width : null;

    current.parentNode.replaceChild(fresh, current);

    var newBody = fresh.querySelector('[data-gbn-drawer-body]');
    if (newBody) newBody.scrollTop = scrollTop;

    // Animate the bar from where it was to where it is now.
    var newFill = fresh.querySelector('[data-gbn-fs-fill]');
    if (newFill && oldWidth !== null) {
      var target = newFill.style.width;
      newFill.style.transition = 'none';
      newFill.style.width = oldWidth;
      newFill.getBoundingClientRect();
      newFill.style.transition = '';
      newFill.style.width = target;
    }

    updateShippingBars(fresh);
    fitAddons();
    setCartCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);

    // Keep focus inside the drawer after the content is swapped out.
    if (drawer.classList.contains('is-open') && !panel.contains(document.activeElement)) {
      panel.focus();
    }
  }

  function refresh() {
    if (!drawer) return Promise.resolve();
    setBusy(true);
    return fetch(rootUrl + '?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function(response) {
        return response.text();
      })
      .then(renderDrawer)
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      })
      .then(function() {
        setBusy(false);
      });
  }

  function showDrawerError(message) {
    var el = drawer && drawer.querySelector('[data-gbn-drawer-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return postJSON(routes.cartChangeUrl + '.js', {
      line: line,
      quantity: quantity,
      sections: [SECTION_ID],
      sections_url: rootUrl
    })
      .then(function(cart) {
        renderDrawer(cart.sections && cart.sections[SECTION_ID]);
      })
      .catch(function(error) {
        showDrawerError(errorMessage(error));
      })
      .then(function() {
        setBusy(false);
      });
  }

  /* ---------------------------------------------------------------------
     Add-ons
     --------------------------------------------------------------------- */
  function setAddButtonState(button, state) {
    if (!button.hasAttribute('data-label')) {
      button.setAttribute('data-label', button.innerHTML);
    }

    if (state === 'busy') {
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span class="gbn-spinner" aria-hidden="true"></span><span class="visually-hidden">' + escapeHtml(theme.strings.loading || 'Loading') + '</span>';
    } else if (state === 'added') {
      button.removeAttribute('aria-busy');
      button.classList.add('is-added');
      button.innerHTML =
        '<span>' + escapeHtml(button.getAttribute('data-added-label') || 'Added') + ' &#10003;</span>';
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('is-added');
      button.innerHTML = button.getAttribute('data-label');
    }
  }

  function showAddonError(button, message) {
    var row = button.closest('.gbn-addon');
    if (!row) return;
    var el = row.querySelector('.gbn-addon__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'gbn-addon__error';
      el.setAttribute('role', 'alert');
      row.appendChild(el);
    }
    el.textContent = message;
  }

  function addAddon(button) {
    var variantId = parseInt(button.getAttribute('data-gbn-add'), 10);
    var inDrawer = drawer && drawer.contains(button);
    var body = { items: [{ id: variantId, quantity: 1 }] };

    if (inDrawer) {
      body.sections = [SECTION_ID];
      body.sections_url = rootUrl;
      setBusy(true);
    }

    setAddButtonState(button, 'busy');

    return postJSON(routes.cartAddUrl + '.js', body)
      .then(function(response) {
        setAddButtonState(button, 'added');
        return new Promise(function(resolve) {
          setTimeout(function() {
            resolve(response);
          }, 450);
        });
      })
      .then(function(response) {
        if (inDrawer) {
          renderDrawer(response.sections && response.sections[SECTION_ID]);
        } else if (document.getElementById('shopify-section-' + CART_PAGE_SECTION_ID)) {
          return refreshCartPage();
        } else if (drawer) {
          // e.g. "Add bundle" on a product page.
          setAddButtonState(button, 'idle');
          open({ trigger: button, refresh: true });
        } else {
          window.location.href = routes.cartUrl;
        }
      })
      .catch(function(error) {
        setAddButtonState(button, 'idle');
        showAddonError(button, errorMessage(error));
      })
      .then(function() {
        setBusy(false);
      });
  }

  /* ---------------------------------------------------------------------
     Cart page: re-render the cart-template section after an add-on is
     added, and re-initialise Debut's cart JS on the new markup.
     --------------------------------------------------------------------- */
  function refreshCartPage() {
    var wrapper = document.getElementById('shopify-section-' + CART_PAGE_SECTION_ID);
    if (!wrapper) {
      window.location.reload();
      return Promise.resolve();
    }

    return Promise.all([
      fetch(routes.cartUrl + '?section_id=' + CART_PAGE_SECTION_ID, { credentials: 'same-origin' }).then(function(r) {
        return r.text();
      }),
      fetch(routes.cartUrl + '.js', { credentials: 'same-origin' }).then(function(r) {
        return r.json();
      })
    ]).then(function(results) {
      var doc = new DOMParser().parseFromString(results[0], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + CART_PAGE_SECTION_ID);
      if (!fresh) {
        window.location.reload();
        return;
      }

      var detail = { detail: { sectionId: CART_PAGE_SECTION_ID } };
      document.dispatchEvent(new CustomEvent('shopify:section:unload', detail));
      wrapper.innerHTML = fresh.innerHTML;
      document.dispatchEvent(new CustomEvent('shopify:section:load', detail));

      updateShippingBars(wrapper);
      initCarousels();
      setCartCount(results[1].item_count);
    });
  }

  /* ---------------------------------------------------------------------
     Cart page add-on carousel. Arrows scroll the track by one card and are
     shown only when the cards overflow. With data-gbn-belt it becomes a
     moving belt: the cards are cloned so the loop is seamless and
     scrollLeft is advanced every frame. It pauses on hover, focus, touch and
     via the pause button, and is skipped when reduced motion is preferred.
     --------------------------------------------------------------------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateCarousel(carousel) {
    var track = carousel.querySelector('[data-gbn-carousel-track]');
    var nav = carousel.querySelector('[data-gbn-carousel-nav]');
    if (!track || !nav) return;

    if (carousel.gbnBelt) {
      nav.hidden = false;
      carousel.querySelector('[data-gbn-carousel-prev]').disabled = false;
      carousel.querySelector('[data-gbn-carousel-next]').disabled = false;
      return;
    }

    var maxScroll = track.scrollWidth - track.clientWidth;
    nav.hidden = maxScroll <= 1;
    carousel.querySelector('[data-gbn-carousel-prev]').disabled = track.scrollLeft <= 1;
    carousel.querySelector('[data-gbn-carousel-next]').disabled = track.scrollLeft >= maxScroll - 1;
  }

  function cardStep(track) {
    var card = track && track.querySelector('.gbn-addon');
    if (!card) return 0;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return card.offsetWidth + gap;
  }

  function scrollCarousel(carousel, direction) {
    var track = carousel.querySelector('[data-gbn-carousel-track]');
    var step = cardStep(track);
    if (!step) return;

    if (carousel.gbnBelt) {
      carousel.gbnBelt.nudge(direction * step);
      return;
    }
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function createBelt(carousel, track) {
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return null;

    var speed = parseFloat(carousel.getAttribute('data-gbn-belt')) || 30;
    var toggle = carousel.querySelector('[data-gbn-belt-toggle]');
    var setWidth = 0;
    var pos = 0;
    var last = 0;
    var holds = { hover: false, focus: false, touch: false, user: false, nudge: false };
    var resumeTimer = null;
    var nudgeTimer = null;
    var selfScroll = false;

    function addClones() {
      var fragment = document.createDocumentFragment();
      originals.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-gbn-clone', '');
        Array.prototype.forEach.call(clone.querySelectorAll('a, button'), function(el) {
          el.setAttribute('tabindex', '-1');
        });
        fragment.appendChild(clone);
      });
      track.appendChild(fragment);
    }

    function wrap(value) {
      if (setWidth <= 0) return value;
      value = value % setWidth;
      return value < 0 ? value + setWidth : value;
    }

    function measure() {
      if (!track.querySelector('[data-gbn-clone]')) addClones();
      // Width of one full set of cards, including the gap after the last one.
      setWidth = track.querySelector('[data-gbn-clone]').offsetLeft - originals[0].offsetLeft;
      // Enough copies that the visible area never runs out of cards.
      var guard = 0;
      while (track.scrollWidth - setWidth < track.clientWidth + 2 && guard < 10) {
        addClones();
        guard++;
      }
      pos = wrap(track.scrollLeft);
    }

    function setScroll(value) {
      selfScroll = true;
      track.scrollLeft = value;
    }

    function paused() {
      return holds.hover || holds.focus || holds.touch || holds.user || holds.nudge;
    }

    function frame(now) {
      if (!document.body.contains(track)) return; // section was re-rendered
      var dt = last ? Math.min(now - last, 100) / 1000 : 0;
      last = now;
      if (!paused() && setWidth > 0 && !document.hidden) {
        pos = wrap(pos + speed * dt);
        setScroll(pos);
      }
      window.requestAnimationFrame(frame);
    }

    // Manual swipes / wheel scrolls: follow them and keep the loop seamless.
    track.addEventListener('scroll', function() {
      if (selfScroll) {
        selfScroll = false;
        return;
      }
      if (holds.nudge) return;
      var wrapped = wrap(track.scrollLeft);
      if (Math.abs(wrapped - track.scrollLeft) > 1) setScroll(wrapped);
      pos = wrapped;
    }, { passive: true });

    carousel.addEventListener('mouseenter', function() { holds.hover = true; });
    carousel.addEventListener('mouseleave', function() { holds.hover = false; });
    carousel.addEventListener('focusin', function(evt) {
      // The arrow / pause buttons shouldn't stop the belt; the cards should.
      holds.focus = !evt.target.closest('[data-gbn-carousel-nav]');
    });
    carousel.addEventListener('focusout', function(evt) {
      if (!carousel.contains(evt.relatedTarget)) holds.focus = false;
    });
    track.addEventListener('touchstart', function() {
      clearTimeout(resumeTimer);
      holds.touch = true;
    }, { passive: true });
    track.addEventListener('touchend', function() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function() { holds.touch = false; }, 3000);
    }, { passive: true });

    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function(evt) {
        evt.preventDefault();
        holds.user = !holds.user;
        toggle.classList.toggle('is-paused', holds.user);
        toggle.setAttribute('aria-label', toggle.getAttribute(holds.user ? 'data-label-play' : 'data-label-pause'));
      });
    }

    carousel.classList.add('is-belt');
    measure();
    window.requestAnimationFrame(frame);

    return {
      measure: measure,
      nudge: function(distance) {
        // A backwards nudge near the start jumps to the identical spot one
        // set later first, so it never hits the edge of the track.
        if (distance < 0 && track.scrollLeft < -distance) setScroll(track.scrollLeft + setWidth);
        holds.nudge = true;
        track.scrollBy({ left: distance, behavior: 'smooth' });
        clearTimeout(nudgeTimer);
        nudgeTimer = setTimeout(function() {
          holds.nudge = false;
          pos = wrap(track.scrollLeft);
          setScroll(pos);
        }, 600);
      }
    };
  }

  function initCarousels() {
    var carousels = document.querySelectorAll('[data-gbn-carousel]');
    Array.prototype.forEach.call(carousels, function(carousel) {
      var track = carousel.querySelector('[data-gbn-carousel-track]');
      if (!track) return;

      if (carousel.hasAttribute('data-gbn-carousel-ready')) {
        if (carousel.gbnBelt) carousel.gbnBelt.measure();
        updateCarousel(carousel);
        return;
      }
      carousel.setAttribute('data-gbn-carousel-ready', '');

      var wantsBelt = carousel.hasAttribute('data-gbn-belt') && !(reduceMotion && reduceMotion.matches);
      if (wantsBelt && track.children.length > 1) {
        carousel.gbnBelt = createBelt(carousel, track);
      }

      updateCarousel(carousel);
      track.addEventListener('scroll', function() {
        updateCarousel(carousel);
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------------
     Events
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(evt) {
    var target = evt.target;

    // Header cart icon opens the drawer instead of going to /cart.
    var cartLink = drawer && target.closest('a.site-header__cart');
    if (cartLink && !evt.metaKey && !evt.ctrlKey && !evt.shiftKey && evt.button === 0) {
      evt.preventDefault();
      open({ trigger: cartLink, refresh: true });
      return;
    }

    var carouselButton = target.closest('[data-gbn-carousel-prev], [data-gbn-carousel-next]');
    if (carouselButton) {
      evt.preventDefault();
      scrollCarousel(
        carouselButton.closest('[data-gbn-carousel]'),
        carouselButton.hasAttribute('data-gbn-carousel-prev') ? -1 : 1
      );
      return;
    }

    var addButton = target.closest('[data-gbn-add]');
    if (addButton) {
      evt.preventDefault();
      addAddon(addButton);
      return;
    }

    if (!drawer || !drawer.contains(target)) return;

    if (target.closest('[data-gbn-drawer-close]')) {
      evt.preventDefault();
      close();
      return;
    }

    var changeButton = target.closest('[data-gbn-change]');
    if (changeButton) {
      evt.preventDefault();
      changeLine(
        parseInt(changeButton.getAttribute('data-gbn-change'), 10),
        Math.max(0, parseInt(changeButton.getAttribute('data-qty'), 10) || 0)
      );
    }
  });

  // Product card "Add to cart" (collection grids): add without leaving the
  // page, then open the drawer. Without JS the form posts to /cart/add.
  document.addEventListener('submit', function(evt) {
    var form = evt.target.closest && evt.target.closest('[data-gbn-card-form]');
    if (!form) return;
    evt.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('.product-card-form__error');
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var label = button.textContent;

    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');

    postJSON(routes.cartAddUrl + '.js', {
      items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: quantity }]
    })
      .then(function() {
        if (qtyInput) qtyInput.value = 1;
        if (drawer) {
          open({ trigger: button, refresh: true });
        } else {
          window.location.href = routes.cartUrl;
        }
      })
      .catch(function(err) {
        if (error) {
          error.textContent = errorMessage(err);
          error.hidden = false;
        }
      })
      .then(function() {
        button.removeAttribute('aria-busy');
        button.textContent = label;
      });
  });

  // Debut's cart page fires this after quantity changes (see theme.js).
  document.addEventListener('gbn:cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) {
      updateShippingBars(document, evt.detail.cart.total_price);
    }

    // Debut rebuilds cart rows from /cart.js, which doesn't include bundle
    // contents, so re-render the cart page from Liquid when bundles or the
    // pre-order notice are shown.
    var cartSection = document.getElementById('shopify-section-' + CART_PAGE_SECTION_ID);
    if (cartSection && cartSection.querySelector('[data-gbn-bundle], [data-gbn-refresh]')) {
      refreshCartPage();
    }
  });

  // Back/forward cache can restore a stale drawer; refresh it.
  window.addEventListener('pageshow', function(evt) {
    if (evt.persisted && drawer) refresh();
  });

  updateShippingBars(document);
  initCarousels();
  window.addEventListener('resize', initCarousels);
  window.addEventListener('load', initCarousels);
  // Theme editor re-renders the cart section on settings changes.
  document.addEventListener('shopify:section:load', initCarousels);

  window.GBNCart = {
    isEnabled: !!drawer,
    open: open,
    close: close,
    refresh: refresh
  };
})();
